import { Tooltip, notification } from 'antd';
import { useEffect, useState } from 'react';

import classNames from 'classnames';
import CopyToClipboard from 'react-copy-to-clipboard';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import DSRequestFormService from '../../../services/DSRequestForm.service';
import { useTranslation } from 'react-i18next';
import usePermission from '../../../hooks/usePermission';

const DsRequestForm = ({ domainSelection, codeCopy, domainName, values }) => {
    const { t } = useTranslation();

    const [isWorkFlowStepConfigured, setIsWorkFlowStepConfigured] =
        useState(false);

    const boldLanguage = (text) => {
        let matchWord = text.match(new RegExp(/lang="[A-Z]+"/));
        if (matchWord) {
            const arr = text.split(matchWord[0]);
            return (
                <>
                    {arr.map((item, index) => (
                        <span key={`code-${index}`}>
                            {item}
                            {index !== arr.length - 1 && <b>{matchWord}</b>}
                        </span>
                    ))}
                </>
            );
        } else return text;
    };

    useEffect(() => {
        const checkWorkflow = async () => {
            const domainId = domainSelection;
            if (domainId) {
                try {
                    const { data } = await DSRequestFormService.checkWorkflow(
                        domainId
                    );
                    if (data?.resultCode === 1) {
                        setIsWorkFlowStepConfigured(
                            data?.resultData.isWorkFlowStepConfigured
                        );
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        };
        checkWorkflow();
    }, [domainSelection]);

    const copy =
        values?.customizeForm?.dataSubjectType.length <= 0
            ? t('DSForm.URLCurrentlyUnavailable')
            : isWorkFlowStepConfigured
            ? codeCopy
            : t('DSForm.URLNotAvailable', { domainName: domainName });

    const { isAuditor } = usePermission();

    return (
        <div hidden={isAuditor} className="space-y-3">
            <div>
                <div className="col-span-4 space-y-3">
                    <div className="space-y-3">
                        <div className="flex space-x-2 items-center">
                            <span className="text-xs font-semibold">
                                {t('Copy the script code below')}
                            </span>
                            <Tooltip
                                placement="right"
                                overlayClassName="min-w-[320px]"
                                title={
                                    <div className="whitespace-pre-line">
                                        {t('DSForm.CopyScript')}
                                    </div>
                                }
                            >
                                <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                    <ExclamationCircleOutlined />
                                </a>
                            </Tooltip>
                        </div>
                        {domainSelection ? (
                            <div>
                                <div className="rounded-md bg-gray-100 px-4">
                                    <div className="py-1 flex justify-between">
                                        <div className="h-20 overflow-y-auto flex justify-between items-center">
                                            <div
                                                className="pl-4 pr-8 whitespace-pre-line"
                                                style={{
                                                    color: domainSelection
                                                        ? '#171717'
                                                        : '#95A0A8',
                                                }}
                                            >
                                                <span
                                                    className={classNames({
                                                        'text-gray-400':
                                                            !isWorkFlowStepConfigured,
                                                    })}
                                                >
                                                    {domainSelection
                                                        ? boldLanguage(copy)
                                                        : t(
                                                              'Please select domain first'
                                                          )}
                                                </span>
                                            </div>
                                            <div className=" absolute right-20 mt-2">
                                                <CopyToClipboard
                                                    onCopy={() => {
                                                        notification['success'](
                                                            {
                                                                message:
                                                                    'Copy to clipboard',
                                                                // description: 'Copy to clipboard',
                                                            }
                                                        );
                                                    }}
                                                    text={codeCopy}
                                                    className="cursor-pointer hover:opacity-80"
                                                >
                                                    {isWorkFlowStepConfigured ? (
                                                        <svg
                                                            width={23}
                                                            height={23}
                                                            viewBox="0 0 23 23"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M5.75 5.87219V15.0938C5.74986 16.0062 6.09677 16.8845 6.72037 17.5505C7.34397 18.2165 8.19756 18.6205 9.108 18.6803L9.34375 18.6875H15.6889C15.5403 19.1078 15.265 19.4718 14.901 19.7292C14.537 19.9867 14.1021 20.1249 13.6562 20.125H8.625C7.48125 20.125 6.38435 19.6706 5.5756 18.8619C4.76685 18.0531 4.3125 16.9562 4.3125 15.8125V7.90625C4.31227 7.46016 4.4504 7.02497 4.70785 6.66067C4.96531 6.29637 5.32942 6.02089 5.75 5.87219ZM16.5312 2.875C17.1031 2.875 17.6516 3.10218 18.0559 3.50655C18.4603 3.91093 18.6875 4.45938 18.6875 5.03125V15.0938C18.6875 15.6656 18.4603 16.2141 18.0559 16.6184C17.6516 17.0228 17.1031 17.25 16.5312 17.25H9.34375C8.77188 17.25 8.22343 17.0228 7.81905 16.6184C7.41468 16.2141 7.1875 15.6656 7.1875 15.0938V5.03125C7.1875 4.45938 7.41468 3.91093 7.81905 3.50655C8.22343 3.10218 8.77188 2.875 9.34375 2.875H16.5312Z"
                                                                fill="#7B67FB"
                                                            />
                                                        </svg>
                                                    ) : (
                                                        <div />
                                                    )}
                                                </CopyToClipboard>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="rounded-md bg-[#ECECEC] px-4">
                                <div className="py-1 flex justify-between">
                                    <div className="h-20 overflow-y-auto flex justify-between pt-3">
                                        <div
                                            className="pl-4 pr-8 whitespace-pre-line font-normal"
                                            style={{
                                                color: '#95A0A8',
                                            }}
                                        >
                                            {t('Please select domain first')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DsRequestForm;
